import { createSelector } from 'reselect';
import {
  filterDefaultRoutes,
  filterDriverRoutes,
  findSectionRoute,
} from '../../models/routes';

export const getRoutesList = (state) => state.routesData.routes;

export const getRouteDepotStats = (state) => state.routesData.depotStats;

export const getScrollToRoute = (state) => state.routesData.scrollToRoute;

export const getDefaultRoutes = createSelector(
  getRoutesList,
  (_, sectionId) => sectionId,
  filterDefaultRoutes
);

export const getDriverRoutes = createSelector(
  getRoutesList,
  filterDriverRoutes
);

export const getSectionRoute = createSelector(
  getRoutesList,
  (_, sectionId) => sectionId,
  findSectionRoute
);
